import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import sortbydot from '../../assets/image/sort_by_group.svg';
import { useDispatch, useSelector } from 'react-redux';
import Button from '../../component/ui/Button';
import Table from '../../component/table/Table';
import Pagination from '../../component/pagination';
import { toast } from 'react-toastify';
import { ExportTable } from '../../store/action/export/Export';
import DeletePaymentMadeModel from './components/DeletePaymentMadeModel';
import {
	deletePaymentMade,
	fetchPaymentMadeList,
	generatePMPdf,
	getPaymentMades,
} from '../../services/payment_made';
import { getDate } from '../../utils/dateUtils';
import pdfMake from 'pdfmake/build/pdfmake';
import {
	clearAdvanceFilter,
	removeSelectedInput,
	setAdvanceFilter,
	setAdvanceFilterPage,
	setAdvanceFilterTotalPage,
	setSelectedInput,
	setSelectedInputData,
	setSelectedInputValue,
} from '../../store/action/advanceFilter';
import axiosInstance from '../../services/axios';
import { APP_API_URL } from '../../utils/xhr-instance';
import advanceFilterOptions from '../../component/Filter/advanceFilterOptions';
import AdvanceFilter from '../../component/Filter/AdvanceFilter';
import addFilter from '../../assets/image/AddFilter.svg';
import clearAllFilter from '../../assets/image/clearAllFilter.svg';
import advanceFilterIcon from '../../assets/image/advanceFilter_white.svg';
import AdvanceFilterSelectInput from '../../component/Filter/AdvanceFilterSelectInput';
import { fetchPaymentMethodList } from '../../services/payment_methods';
import { capitalizeFirstLetter } from '../../utils/stringUtils';
import { getFiltersParams } from '../../helper';
import { IoIosArrowRoundDown, IoIosArrowRoundUp } from 'react-icons/io';
import { generatePaymentMadePdf } from './components/generatePaymentMadePdf';
import PageLoader from '../../component/PageLoader';
import { hasPermission } from '../../utils/controller';

const sortIconMap = {
	asc: <IoIosArrowRoundUp />,
	desc: <IoIosArrowRoundDown />,
};

const PaymentMade = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const {
		page: advanceFilterPage,
		totalPages: advanceFilterTotalPages,
		pageSize: advanceFilterPageSize,
		selectedInputs,
		isAdvanceFilterApplied,
	} = useSelector((state) => state.advanceFilter);
	const suburl = localStorage.getItem('suburl');
	const [loader, setLoader] = useState(false);
	const [bulkAction, setBulkAction] = useState([]);
	const [headerDropDown, setHeaderDropDown] = useState('All Payment Made');
	const [sortDirection, setSortDirection] = useState({ payment_made_id: 'asc' });
	const [isDeleteBulkConfirmationModalOpen, setIsDeleteBulkConfirmationModalOpen] = useState(false);
	const [selectedPaymentMadeListForDelete, setSelectedPaymentMadeListForDelete] = useState([]);
	const [isAdvanceFilterOpen, setIsAdvanceFilterOpen] = useState(false);
	const [paymentMadeParams, setPaymentMadeParams] = useState({
		page: 1,
		pageSize: 20,
		orderBy: 'created_at',
		sortBy: 'desc',
		filters: {},
	});
	const [deselectRows, setDeselectRows] = useState(null);
	const [paymentMade, setPaymentMade] = useState({
		data: [],
		totalPages: 0,
	});
	const [loading, setLoading] = useState({
		pdf: {
			button: 'pdf',
			isLoading: false,
		},
		download: {
			button: 'download',
			isLoading: false,
		},
	});
	const [paymentMethods, setPaymentMethods] = useState([]);
	const user = useSelector((state) => state?.userInfo?.userInfo?.data);
	const PaymentMadeColoum = [
		{
			field: '',
			headerClass: 'HeaderBg',
			checkboxSelection: true,
			headerCheckboxSelection: true,
			minWidth: 50,
			maxWidth: 50,
			lockPosition: true,
		},

		{
			field: 'DATE',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth:93,
			flex: 1,
			cellClass: 'left-align',
			headerComponent: () => (
				<div
					className="header-clickable"
					onClick={() => sortDataList({ orderBy: 'date', sortBy: 'asc' })}
				>
					<div className="header-inner-55">
						<p className="table-header__label_invoices mb-0">
							DATE
							<span className="sort-icon">
								{sortIconMap[sortDirection?.date]}
							</span>
						</p>
					</div>
				</div>
			),
		},

		{
			field: 'PAYMENT#',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 100,
			flex: 1,
			cellClass: 'left-align',
			headerComponent: () => (
				<div
					className="header-clickable"
					onClick={() =>
						sortDataList({ orderBy: 'payment_number', sortBy: 'asc' })
					}
				>
					<div className="header-inner-55">
						<p className="table-header__label_invoices mb-0">
							PAYMENT#
							<span className="sort-icon">
								{sortIconMap[sortDirection?.payment_number]}
							</span>
						</p>
					</div>
				</div>
			),
		},

		{
			field: 'VENDOR NAME',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 150,
			flex: 1,
			cellClass: 'left-align',
			headerComponent: () => (
				<div
					className="header-clickable"
					onClick={() =>
						sortDataList({ orderBy: 'vendor_name', sortBy: 'asc' })
					}
				>
					<div className="header-inner-55">
						<p className="table-header__label_invoices mb-0">
							VENDOR NAME
							<span className="sort-icon">
								{sortIconMap[sortDirection?.vendor_name]}
							</span>
						</p>
					</div>
				</div>
			),
		},

		{
			field: 'MODE',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 120,
			flex: 1,
			cellClass: 'left-align',
			headerComponent: () => (
				<div
					className="header-clickable"
					onClick={() =>
						sortDataList({ orderBy: 'payment_mode', sortBy: 'asc' })
					}
				>
					<div className="header-inner-55">
						<p className="table-header__label_invoices mb-0">
							MODE
							<span className="sort-icon">
								{sortIconMap[sortDirection?.payment_mode]}
							</span>
						</p>
					</div>
				</div>
			),
		},

		{
			field: 'AMOUNT',
			headerClass: 'HeaderBg right-align',
			suppressSizeToFit: true,
			minWidth: 100,
			flex: 1,
			cellClass: 'right-align',
			headerComponent: () => (
				<div
					className="header-clickable header-right"
					onClick={() =>
						sortDataList({ orderBy: 'payment_amount', sortBy: 'asc' })
					}
				>
					<div className="header-inner-55">
						<p className="d-flex align-items-center justify-content-end text-dark  table-header__label_invoices mb-0">
							AMOUNT
							<span className="sort-icon">
								{sortIconMap[sortDirection?.payment_amount]}
							</span>
						</p>
					</div>
				</div>
			),
		},
	];


	const handleDeselectAll = (deselectAllRowsFn) => {
		setDeselectRows(() => deselectAllRowsFn);
	};

	const navigateRouter = (path) => {
		navigate(path);
	};
	const onRowClick = (id) => {
		if (id && hasPermission('purchases.payments_made.view', user?.role?.role_permissions)) {
			navigate(`/user/${suburl}/payment-made-details/${id}`);
		}
	};

	const FilterDatalist = (param, value, dropDownData) => {
		if (isAdvanceFilterApplied && dropDownData === 'All Payment Made') {
			dispatch(clearAdvanceFilter());
			setHeaderDropDown('All Payment Made');
			return;
		}
		setHeaderDropDown(dropDownData);
		const updatedSelectedInput = selectedInputs.map((input) => {
			if (input.key === 'payment_mode') {
				return {
					...input,
					value: dropDownData,
				};
			}
			return input;
		});
		dispatch(setSelectedInput({ key: 'payment_mode', label: 'Status' }));
		dispatch(setSelectedInputValue({ key: 'payment_mode', value: dropDownData }));
		dispatch(setAdvanceFilter({ isAdvanceFilterApplied: true }));
		const selectInputData = paymentMethods?.map((method) => {
			return {
				key: method,
				value: capitalizeFirstLetter(method),
			};
		});
		dispatch(setSelectedInputData({ key: 'payment_mode', data: selectInputData }));
		const params = getFiltersParams(updatedSelectedInput);
		handleApplyFilters(params);
	};

	async function handlePMPrintAndDownloadPdf(type = 'print') {
		try {
			setLoading((prev) => {
				const obj = {};
				obj.pdf = {
					button: type,
					isLoading: true,
				};

				return {
					...prev,
					...obj,
				};
			});
			const pdf_details = await generatePMPdf(bulkAction.join(','), true);
			const url = pdf_details.signed_url;

			if (type === 'print') {
				window.open(url, '_blank');
			}

			if (type === 'download') {
				const fileName = `merged_purchase_payment_made_${Date.now()}.pdf`;
				const response = await fetch(url);
				const blob = await response.blob();
				const blobUrl = window.URL.createObjectURL(blob);
				const link = document.createElement('a');
				link.href = blobUrl;
				link.download = fileName;
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				window.URL.revokeObjectURL(blobUrl);
			}
		} catch (err) {
		} finally {
			setLoading((prev) => ({
				...prev,
				pdf: {
					...prev.pdf,
					isLoading: false,
				},
				download: {
					...prev.download,
					isLoading: false,
				},
			}));
		}
	}

	const sortDataList = (param) => {
		const newDirection = sortDirection[param.orderBy] === 'desc' ? 'asc' : 'desc';
		setSortDirection({ [param.orderBy]: newDirection });
		if (isAdvanceFilterApplied) {
			dispatch(setAdvanceFilter({ orderBy: param.orderBy, sortBy: newDirection }));
			const params = getFiltersParams(selectedInputs);
			handleApplyFilters(params);
		} else {
			setPaymentMadeParams((prev) => ({
				...prev,
				orderBy: param.orderBy,
				sortBy: newDirection,
			}));
		}
	};

	const exportData = (param) => {
		ExportTable(param);
	};

	async function handleBulkDelete() {
		try {
			await deletePaymentMade(bulkAction);
			toast.success('Payment Made Deleted Successfully.');
			setIsDeleteBulkConfirmationModalOpen(false);
			setBulkAction([]);
			handleFetchPaymentMade();
		} catch (error) {
			toast.error(error?.message || 'Something went wrong');
		}
	}

	function handleOpenBulkDeletePaymentMadeModal() {
		const selectedPMList = paymentMade?.data?.reduce((acc, item) => {
			if (bulkAction.includes(item.id)) {
				acc.push(item['PAYMENT#']);
				return acc;
			}
			return acc;
		}, []);
		setSelectedPaymentMadeListForDelete(selectedPMList);
		setIsDeleteBulkConfirmationModalOpen(true);
	}

	async function handleOnFocusSelectedFilterInput(key) {
		let selectInputData = [];
		if (key === 'payment_mode') {
			selectInputData = paymentMethods?.map((method) => {
				return {
					key: method,
					value: capitalizeFirstLetter(method),
				};
			});
		} else {
			const { data } = await fetchPaymentMadeList({
				pageSize: 1000,
				filterBy: key,
				filterValue: '',
			});
			selectInputData = data?.reduce((acc, pb) => {
				if (key === 'vendor_name') {
					acc.push({
						key: pb.vendor?.vendor_name,
						value: pb.vendor?.vendor_name,
					});
					return acc;
				} else if (key === 'purchase_receive_numbder') {
					acc.push({
						key: pb?.purchase_receive?.purchase_order_number,
						value: pb?.purchase_receive?.purchase_order_number,
					});
					return acc;
				} else {
					acc.push({
						key: pb[key],
						value: pb[key],
					});
					return acc;
				}
			}, []);
		}

		dispatch(setSelectedInputData({ key, data: selectInputData }));
	}

	async function searchSelectedInputItems(key, value) {
		try {
			let optionsList;
			if (key === 'payment_mode') {
				optionsList = paymentMethods?.map((method) => {
					return {
						key: method,
						value: capitalizeFirstLetter(method),
					};
				});
			} else {
				const { data } = await fetchPaymentMadeList({
					pageSize: 1000,
					filterBy: key,
					filterValue: value,
				});
				optionsList = data?.map((pm) => ({
					key: key === 'vendor_name' ? pm?.vendor?.vendor_name : pm[key],
					value: key === 'vendor_name' ? pm?.vendor?.vendor_name : pm[key],
				}));
			}

			dispatch(setSelectedInputData({ key, data: optionsList }));
		} catch (error) {
			toast.error('Something went wrong!');
		}
	}

	async function handleApplyFilters(params) {
		try {
			if (Object.keys(params).length === 0) return;

			if (params?.payment_mode) {
				setHeaderDropDown(params?.payment_mode);
			}

			const { payments, totalPages } = await getPaymentMades({
				page: advanceFilterPage,
				pageSize: advanceFilterPageSize,
				filters: params,
			});
			const mappedTableData = payments
				? payments.map((pm) => {
					return {
						id: pm.payment_made_id,
						'PAYMENT#': pm.payment_number,
						DATE: getDate(pm?.date),
						'VENDOR NAME': pm?.vendor_name,
						MODE: pm?.payment_mode,
						AMOUNT: Number(pm?.payment_amount).toFixed(2),
					};
				})
				: [];
			setPaymentMade((prev) => ({
				...prev,
				data: mappedTableData,
				totalPages: totalPages,
			}));
			dispatch(setAdvanceFilterTotalPage({ totalPages: totalPages }));
			setIsAdvanceFilterOpen(false);
		} catch (error) {
			toast.error('Something went wrong! Try again.');
		}
	}

	async function handleFetchPaymentMethod() {
		try {
			const data = await fetchPaymentMethodList({ page: 1, limit: 100 });
			if (Array.isArray(data.paymentMethods) && data.paymentMethods.length) {
				setPaymentMethods([...new Set(data.paymentMethods.map((pm) => pm.payment_method_name))]);
			}
		} catch (error) {
			toast.error('Something went wrong!');
		}
	}

	async function handleFetchPaymentMade() {
		try {
			setLoader(true);
			const { payments, totalPages } = await getPaymentMades(paymentMadeParams);
			const mappedTableData = payments?.map((pm) => {
				return {
					id: pm.payment_made_id,
					'PAYMENT#': pm.payment_number,
					DATE: getDate(pm?.date),
					'VENDOR NAME': pm?.vendor_name,
					MODE: pm?.payment_mode,
					AMOUNT: Number(pm?.payment_amount).toFixed(2),
				};
			});
			setPaymentMade((prev) => ({
				...prev,
				data: mappedTableData,
				totalPages,
			}));
		} catch (error) {
			toast.error('Somethings went wrong!');
		} finally {
			setLoader(false);
		}
	}

	useEffect(() => {
		handleFetchPaymentMethod();
	}, []);

	useEffect(() => {
		if (isAdvanceFilterApplied) {
			const params = getFiltersParams(selectedInputs);
			handleApplyFilters(params);
		} else {
			handleFetchPaymentMade();
		}
	}, [paymentMadeParams, advanceFilterPage, advanceFilterPageSize, isAdvanceFilterApplied]);

	return (
		<div style={{ overflow: 'auto' }}>
			{bulkAction && bulkAction.length > 0 ? (
				<div
					className="product-pg-header"
					style={{ padding: '1.6rem 1rem' }}
				>
					<div className="dropdown text-end">
						<p className="d-block link-dark text-decoration-none">Bulk Actions</p>
					</div>
					<div className="add-product-button">
						<Button
							type="button"
							button="Print"
							disabled={
								!hasPermission(
									'purchases.payments_made.download_print_pdf',
									user?.role?.role_permissions,
								)
							}
							className="mt-0 px-4 btn-gray"
							loader={loading.pdf.isLoading}
							onClick={() => handlePMPrintAndDownloadPdf('print')}
						/>
						<Button
							type="button"
							button="Delete"
							disabled={
								!hasPermission('purchases.payments_made.delete', user?.role?.role_permissions)
							}
							className="mt-0 px-4 btn-gray"
							onClick={handleOpenBulkDeletePaymentMadeModal}
						/>
						<Button
							type="button"
							button=""
							className="mt-0 px-4 btn-danger"
							close
							onClick={() => {
								setBulkAction(false);
								setBulkAction([]);
								deselectRows && deselectRows();
							}}
						/>
					</div>
				</div>
			) : (
				<div className="product-pg-header add-product">
					<div
						className="dropdown text-end d-flex"
						style={{ gap: '12px', display: 'flex', alignItems: 'center' }}
					>
						<a
							className="d-block link-dark text-decoration-none dropdown-toggle"
							id="dropdownUser1"
							data-bs-toggle="dropdown"
							aria-expanded="false"
						>
							<p>{headerDropDown}</p>
						</a>
						<ul
							className="dropdown-menu font-14"
							aria-labelledby="dropdownUser1"
							style={{ minWidth: '240px' }}
						>
							<li>
								<a
									className="dropdown-item"
									onClick={() =>
										FilterDatalist(
											{ filterBy: null, filterValue: null },
											'active',
											'All Payment Made',
										)
									}
								>
									All
								</a>
							</li>
							{paymentMethods?.length > 0 &&
								paymentMethods?.map((name) => (
									<li>
										<a
											className="dropdown-item"
											onClick={() =>
												FilterDatalist(
													{ filterBy: 'payment_mode', filterValue: name },
													'active',
													capitalizeFirstLetter(name),
												)
											}
										>
											{capitalizeFirstLetter(name)}
										</a>
									</li>
								))}
						</ul>
						<div>
							{isAdvanceFilterApplied ? (
								<div>
									<button
										onClick={() => {
											dispatch(clearAdvanceFilter());
											setHeaderDropDown('All Payment Made');
										}}
										style={{
											background: 'transparent',
											color: '#FF0000',
											fontSize: '14px',
											cursor: 'pointer',
											fontWeight: '600',
											lineHeight: '24px',
										}}
									>
										<img
											src={clearAllFilter}
											alt=""
											style={{ width: '18px', height: '18px', marginRight: '8px' }}
										/>
										Clear All Filters
									</button>
								</div>
							) : (
								<Button
									type="button"
									button="Advanced Filters"
									className="mt-0 px-4 btn-primary"
									onClick={() => setIsAdvanceFilterOpen(true)}
									icon={advanceFilterIcon}
								/>
							)}
						</div>
					</div>

					<div className="add-product-button column-gap-0">
						<Button
							type="button"
							className="btn-primary mt-0 px-3"
							disabled={
								!hasPermission('purchases.payments_made.create', user?.role?.role_permissions)
							}
							button="Create New Payment Made"
							add
							onClick={() => navigateRouter(`/user/${suburl}/payment-made-create`)}
						/>
						<div className="dropdown text-end ms-3">
							<a
								href="#"
								className="d-block link-dark text-decoration-none"
								id="dropdownUser1"
								data-bs-toggle="dropdown"
								aria-expanded="false"
							>
								<img src={sortbydot} />
							</a>
							{/* date , reason, created_at , description,status,reference_number, */}
							<ul
								className="dropdown-menu font-14"
								aria-labelledby="dropdownUser1"
								style={{ minWidth: '240px' }}
							>
								<li>
									<a className="dropdown-item sortBy">Sort By</a>
								</li>
								<li>
									<a
										style={{
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'space-between',
										}}
										className="dropdown-item"
										onClick={() => sortDataList({ orderBy: 'created_at', sortBy: 'asc' })}
									>
										Created Time
										<span>{sortIconMap[sortDirection?.created_at]}</span>
									</a>
								</li>
								<li>
									<a
										style={{
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'space-between',
										}}
										className="dropdown-item"
										onClick={() => sortDataList({ orderBy: 'date', sortBy: 'asc' })}
									>
										Date
										<span>{sortIconMap[sortDirection?.date]}</span>
									</a>
								</li>
								<li>
									<a
										style={{
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'space-between',
										}}
										className="dropdown-item"
										onClick={() => sortDataList({ orderBy: 'payment_made_id', sortBy: 'asc' })}
									>
										Payment#
										<span>{sortIconMap[sortDirection?.payment_made_id]}</span>
									</a>
								</li>
								<li>
									<a
										style={{
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'space-between',
										}}
										className="dropdown-item"
										onClick={() => sortDataList({ orderBy: 'vendor_name', sortBy: 'asc' })}
									>
										Vendor Name
										<span>{sortIconMap[sortDirection?.vendor_name]}</span>
									</a>
								</li>
								<li>
									<a
										style={{
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'space-between',
										}}
										className="dropdown-item"
										onClick={() => sortDataList({ orderBy: 'payment_mode', sortBy: 'asc' })}
									>
										Mode
										<span>{sortIconMap[sortDirection?.payment_mode]}</span>
									</a>
								</li>
								<li>
									<a
										style={{
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'space-between',
										}}
										className="dropdown-item"
										onClick={() => sortDataList({ orderBy: 'payment_amount', sortBy: 'asc' })}
									>
										Amount
										<span>{sortIconMap[sortDirection?.payment_amount]}</span>
									</a>
								</li>
								<li>
									<a
										className={`dropdown-item ${!hasPermission('purchases.payments_made.export', user?.role?.role_permissions) ? 'disabled' : ''}`}
										onClick={() => exportData(`payment_made`)}
									>
										Export Payment Made
									</a>
								</li>

								<li>
									<a
										className="dropdown-item"
										onClick={() => {
											setHeaderDropDown('All Payment Made');
											setPaymentMadeParams({
												page: 1,
												pageSize: 20,
												orderBy: 'payment_made_id',
												sortBy: 'asc',
												filterBy: null,
												filterValue: null,
											});
										}}
									>
										Refresh
									</a>
								</li>
							</ul>
						</div>
					</div>
				</div>
			)}

			<div
				style={{
					display: 'flex',
					alignItems: 'center',
					gap: 10,
					padding: '0px 10px',
				}}
			>
				{isAdvanceFilterApplied && (
					<div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
						{selectedInputs.map((item) => (
							<AdvanceFilterSelectInput
								key={item.key}
								options={item?.data}
								placeholder={`Select ${item?.label}`}
								value={item?.value}
								disabled={false}
								onFocusCb={() => {
									if (item.value === '') {
										handleOnFocusSelectedFilterInput(item?.key);
									}
								}}
								onChange={(value) => { }}
								onSelect={(option) => {
									const updatedSelectedInput = selectedInputs.map((input) => {
										if (input.key === item?.key) {
											return {
												...input,
												value: option?.value,
											};
										}
										return input;
									});
									const params = getFiltersParams(updatedSelectedInput);
									handleApplyFilters(params);
									dispatch(setSelectedInputValue({ key: item?.key, value: option.value }));
								}}
								removeInput={() => {
									dispatch(removeSelectedInput({ key: item?.key }));
									if (item?.key === 'payment_mode') {
										setHeaderDropDown('All Payment Made');
									}
									const params = getFiltersParams(
										selectedInputs.filter((input) => input.key !== item?.key),
									);
									handleApplyFilters(params);
								}}
								className="selectInput"
							/>
						))}
						<div style={{ marginBottom: '8px', cursor: 'pointer' }}>
							<img
								src={addFilter}
								alt="Apply Filter"
								onClick={() => setIsAdvanceFilterOpen(true)}
							/>
						</div>
					</div>
				)}
			</div>

			{isDeleteBulkConfirmationModalOpen && (
				<DeletePaymentMadeModel
					isDeleteBulkConfirmationModalOpen={isDeleteBulkConfirmationModalOpen}
					setIsDeleteBulkConfirmationModalOpen={setIsDeleteBulkConfirmationModalOpen}
					selectedPaymentMadeListForDelete={selectedPaymentMadeListForDelete}
					handleBulkDelete={handleBulkDelete}
					PaymentMadeLength={bulkAction.length}
				/>
			)}

			{loader ? (
				<PageLoader />
			) : (
				<div className="productTable-body">
					<Table
						row={paymentMade.data}
						coloum={PaymentMadeColoum}
						className="productTable"
						onRowClick={onRowClick}
						bulkAction={bulkAction}
						action={setBulkAction}
						style={isAdvanceFilterApplied ? { height: 'calc(100vh - 185px)' } : {}}
						onDeselectAll={handleDeselectAll}
					/>
				</div>
			)}
			<Pagination
				currentPage={isAdvanceFilterApplied ? advanceFilterPage : paymentMadeParams.page}
				totalPages={isAdvanceFilterApplied ? advanceFilterTotalPages : paymentMade.totalPages}
				onChangePage={(page) => {
					if (isAdvanceFilterApplied) {
						dispatch(setAdvanceFilterPage({ page: page }));
					} else {
						setPaymentMadeParams((prev) => ({
							...prev,
							page,
						}));
					}
				}}
				pageSize={isAdvanceFilterApplied ? advanceFilterPageSize : paymentMadeParams.pageSize}
				setParam={(value) => {
					if (isAdvanceFilterApplied) {
						dispatch(setAdvanceFilterPage({ page: 1, pageSize: value }));
					} else {
						setPaymentMadeParams((prev) => ({
							...prev,
							pageSize: value,
							page: 1,
						}));
					}
				}}
			/>

			{/* Advance Filter  */}
			{isAdvanceFilterOpen && (
				<AdvanceFilter
					modalLabel="Note: You can create a bill for either Yet to Receive Items or Received Items."
					isOpen={isAdvanceFilterOpen}
					advanceFilterOptions={advanceFilterOptions?.payment_made}
					onFocusSelectedFilterInput={handleOnFocusSelectedFilterInput}
					handleOnChangeSelectedFilterInput={(key, value) => searchSelectedInputItems(key, value)}
					onClose={() => {
						setIsAdvanceFilterOpen(false);
					}}
					onApply={handleApplyFilters}
				/>
			)}
		</div>
	);
};

export default PaymentMade;
